import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const GetCatalogsInfoSchema = z.object({});
export type GetCatalogsInfoCommand = z.infer<typeof GetCatalogsInfoSchema>;

export const CatalogsInfoResponseSchema = z.object({
  testCollectionsAvailability: z.record(
    z.object({
      available: z.boolean(),
      createdAt: z.any().nullable().or(z.string().nullable()), // Allowing any for Date/String flexibility
    }),
  ),
  syncRequired: z.boolean(),
  downloadUrls: z.object({
    nomenclatures: z.string(),
    duties: z.string(),
    madb: z.string(),
  }),
});
export type CatalogsInfoResponse = z.infer<typeof CatalogsInfoResponseSchema>;

export const SyncIndexesSchema = z.object({});
export type SyncIndexesCommand = z.infer<typeof SyncIndexesSchema>;

export const SyncIndexesResponseSchema = z.object({
  complete: z.boolean(),
});
export type SyncIndexesResponse = z.infer<typeof SyncIndexesResponseSchema>;

export const catalogsContract = c.router({
  getCatalogsInfo: {
    method: 'GET',
    path: '/external-api/catalogs-info',
    responses: { 200: CatalogsInfoResponseSchema },
  },
  syncIndexes: {
    method: 'POST',
    path: '/external-api/sync-indexes',
    body: c.noBody(),
    responses: { 200: SyncIndexesResponseSchema },
  },
});
